module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 myclass",
    attrs: {
      "id": "نرجسية"
    }
  }, [_c('div', {
    staticClass: "section level2",
    staticStyle: {
      "padding-top": "130px"
    },
    attrs: {
      "id": "narcissistic"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عندما تحتسي قهوة وبيدك كتاب، حينها لا حاجة إلى الكعك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بل استمتع بالطعم الحلو، مع قراءة كُل حرف.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("When you drink coffee and you have a book between your hand, then you don’t need a cake, just enjoy the sweet taste with every letter.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لماذا تعتقد بأن حياتك يجب أن تكون سعيدة دائماً؟")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("******")]), _vm._v(" "), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd6db54c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0005.vue
// module id = 99
// module chunks = 0